module.exports = __webpack_public_path__ + "SPFicon.png?6d3a7e70df637ec69d5eff7c1116d834";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/SPFicon.png
// module id = 50
// module chunks = 0